import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';

export const GRADES_6_MATERIALS: GradeMaterials = {
  categories: [
    {
      headingEn: 'Introductory items',
      headingEs: 'Elementos introductorios',
      items: [
        {
          id: 'program-guide-6',
          labelEn: 'Program Guide 6',
          labelEs: 'Guía del programa 6',
          subLabelEn: 'website\'s program section',
          subLabelEs: 'sección del programa de la página web',
          filePath: 'assets/printables/en/6/Program_Guide_6.pdf',
          filePathEs: 'assets/printables/es/6/Program_Guide_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-parents-6',
          labelEn: 'Letter to parents',
          labelEs: 'Carta para los padres',
          filePath: 'assets/printables/en/6/Letter_Parents_6.pdf',
          filePathEs: 'assets/printables/es/6/Letter_Parents_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-administrator-6',
          labelEn: 'Letter to administrator',
          labelEs: 'Carta para los administradores',
          filePath: 'assets/printables/en/6/Letter_Administrator_6.docx',
          filePathEs: 'assets/printables/es/6/Letter_Administrator_6_ES.docx',
          iconType: 'doc'
        }
      ]
    },
    {
      headingEn: 'Employment',
      headingEs: 'Empleo',
      items: [
        {
          id: 'payday-video-6',
          labelEn: 'Payday video',
          labelEs: 'Video sobre el día de pago',
          filePath: 'assets/video/CE_S01.mp4',
          filePathEs: 'assets/video/CE_S01.mp4',
          iconType: 'video'
        },
        {
          id: 'job-application-6',
          labelEn: 'Job application',
          labelEs: 'Aplicación de trabajo',
          filePath: 'assets/printables/en/6/Job_Application_6.pdf',
          filePathEs: 'assets/printables/es/6/Job_Application_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-offer-6',
          labelEn: 'Job offer',
          labelEs: 'Oferta de trabajo',
          filePath: 'assets/printables/en/6/Job_Offer_6.pdf',
          filePathEs: 'assets/printables/es/6/Job_Offer_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-posters-6',
          labelEn: 'Job posters',
          labelEs: 'Afiches de trabajo',
          filePath: 'assets/printables/en/6/Job_Posters_6.pdf',
          filePathEs: 'assets/printables/es/6/Job_Posters_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'paycheck-6',
          labelEn: 'Paychecks',
          labelEs: 'Sueldo',
          filePath: 'assets/printables/en/6/Paycheck_6.pdf',
          filePathEs: 'assets/printables/es/6/Paycheck_6_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Banking',
      headingEs: 'Bancario/a',
      items: [
        {
          id: 'bank-log-6',
          labelEn: 'Bank log',
          labelEs: 'Registro bancario',
          filePath: 'assets/printables/en/6/Bank_Log_6.pdf',
          filePathEs: 'assets/printables/es/6/Bank_Log_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bank-slip-6',
          labelEn: 'Bank slips',
          labelEs: 'Recibos bancarios',
          filePath: 'assets/printables/en/6/Bank_Slip_6.pdf',
          filePathEs: 'assets/printables/es/6/Bank_Slip_6_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Fines',
      headingEs: 'Multas',
      items: [
        {
          id: 'fine-ticket-6',
          labelEn: 'Fine tickets',
          labelEs: 'Tiquetes de multa',
          filePath: 'assets/printables/en/6/Fine_Ticket_6.pdf',
          filePathEs: 'assets/printables/es/6/Fine_Ticket_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'offense-log-6',
          labelEn: 'Offense log',
          labelEs: 'Registro de ofensas',
          filePath: 'assets/printables/en/6/Offense_Log_6.pdf',
          filePathEs: 'assets/printables/es/6/Offense_Log_6_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Cash',
      headingEs: 'Dinero',
      items: [
        {
          id: 'bills-50-6',
          labelEn: '$50 bills',
          labelEs: 'Billetes de $50',
          subLabelEn: 'small bills: see grades 2—3',
          subLabelEs: 'facturas pequeñas: refiera los grados 2-3',
          filePath: 'assets/printables/en/6/Bills_50_6.pdf',
          filePathEs: 'assets/printables/es/6/Bills_50_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-100-6',
          labelEn: '$100 bills',
          labelEs: 'Billetes de $100',
          filePath: 'assets/printables/en/6/Bills_100_6.pdf',
          filePathEs: 'assets/printables/es/6/Bills_100_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-500-6',
          labelEn: '$500 bills',
          labelEs: 'Billetes de $500',
          filePath: 'assets/printables/en/6/Bills_500_6.pdf',
          filePathEs: 'assets/printables/es/6/Bills_500_6_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Rent & deeds',
      headingEs: 'Alquiler y título de propiedad',
      items: [
        {
          id: 'rental-agreement-6',
          labelEn: 'Rental agreement',
          labelEs: 'Contrato de alquiler',
          filePath: 'assets/printables/en/6/Rental_Agreement_6.pdf',
          filePathEs: 'assets/printables/es/6/Rental_Agreement_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'rent-log-6',
          labelEn: 'Rent log',
          labelEs: 'Registro de alquiler',
          filePath: 'assets/printables/en/6/Rent_Log_6.pdf',
          filePathEs: 'assets/printables/es/6/Rent_Log_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'unpaid-rent-notice-6',
          labelEn: 'Unpaid rent notice',
          labelEs: 'Aviso de renta no pagada',
          filePath: 'assets/printables/en/6/Unpaid_Rent_Notice_6.pdf',
          filePathEs: 'assets/printables/es/6/Unpaid_Rent_Notice_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'desk-deed-6',
          labelEn: 'Deed to desk',
          labelEs: 'Título de propiedad del escritorio',
          filePath: 'assets/printables/en/6/Desk_Deed_6.pdf',
          filePathEs: 'assets/printables/es/6/Desk_Deed_6_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Auctions',
      headingEs: 'Subastas',
      items: [
        {
          id: 'auction-video-6',
          labelEn: 'Auction video',
          labelEs: 'Video sobre subastas',
          filePath: 'assets/video/CE_S04.mp4',
          filePathEs: 'assets/video/CE_S04.mp4',
          iconType: 'video'
        },
        {
          id: 'auction-record-6',
          labelEn: 'Auction record form',
          labelEs: 'Formulario de registro de subasta',
          filePath: 'assets/printables/en/6/Auction_Record_6.pdf',
          filePathEs: 'assets/printables/es/6/Auction_Record_6_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'auction-paddle-6',
          labelEn: 'Auction paddle',
          labelEs: 'Paleta de subastas',
          filePath: 'assets/printables/en/6/Auction_Paddle_6.pdf',
          filePathEs: 'assets/printables/es/6/Auction_Paddle_6_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Year-end certificates',
      headingEs: 'Certificados de fin de año',
      items: [
        {
          id: 'saver-certs-6',
          labelEn: 'Saver certificates (Includes Saver, Super, and Ultimate awards)',
          labelEs: 'Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)',
          filePath: 'assets/printables/en/6/Saver_Certs_6.pdf',
          filePathEs: 'assets/printables/es/6/Saver_Certs_6_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Posters & handouts',
      headingEs: 'Afiches y folletos',
      items: [
        {
          id: 'bonus-list-6',
          labelEn: 'Bonus list',
          labelEs: 'Lista de bonificaciones',
          filePath: 'assets/printables/en/6/Bonus_List_6.docx',
          filePathEs: 'assets/printables/es/6/Bonus_List_6_ES.doc',
          iconType: 'doc'
        },
        {
          id: 'fine-list-6',
          labelEn: 'Fine list',
          labelEs: 'Lista de multas',
          filePath: 'assets/printables/en/6/Fine_List_6.docx',
          filePathEs: 'assets/printables/es/6/Fine_List_6_ES.doc',
          iconType: 'doc'
        }
      ]
    }
  ],
  supplies: {
    headingEn: 'Supplies to have on hand',
    headingEs: 'Suministros para tener al alcance',
    items: [
      { labelEn: 'Envelopes', labelEs: 'Sobres' },
      { labelEn: 'Portfolio folders', labelEs: 'Carpetas de portafolios' },
      { labelEn: 'Cash drawer or box', labelEs: 'Caja de dinero' },
      { labelEn: 'Popsicle sticks for auction paddles', labelEs: 'Palos de paleta para las paletas de subasta' },
      { labelEn: 'Sticky notes', labelEs: 'Notas adhesivas' },
      { labelEn: 'Clipboard', labelEs: 'Portapapeles' },
      { labelEn: 'Auction items', labelEs: 'Artículos de subasta' }
    ]
  }
};
